import React from 'react';
import LiveScore from '../components/LiveScore/LiveScore';
import MatchCard from '../components/MatchCard/MatchCard';
import Team3 from '../img/Team3.jpg'
import Team4 from '../img/Team4.jpg'
import ImageCollage from './ImageCollage';

function Home() {
  const images = [Team3, Team4 ];

  return (
    <div className="home">
      <h1>Welcome to Indosam Cricket Club</h1>
      <LiveScore />
     
      {
      images.map((src) => (<ImageCollage images={src}></ImageCollage>))
      }

      <h2>Upcoming Matches</h2>
      <div className="matches">
       
        <MatchCard 
          title="Indosam CC vs Team A" 
          date="April 13, 2025" 
          venue="Indosam Stadium" 
        />
        {/* Add more MatchCard components */}
      </div>
    </div>
  );
}

export default Home;